/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { IEditor } from "../../IEditor";
import { RESOURCE_TYPES } from "@adapptio/lib-core";
import { registerCommands } from "./Commands";
import { registerMenus } from "./Menus";
import { ThemeEditor, ThemeEditorComponent } from "./ThemeEditor";

export function ThemeEditorModule(dc: IEditor): void {
	dc.get("logger").debug("ThemeEditor module enabled.");

	const resourceSvc = dc.get("resourceService");
	const viewSvc = dc.get("viewService");

	viewSvc.registerView("themeEditor.edit", ThemeEditor, ThemeEditorComponent);

	resourceSvc.registerResourceCreateCommand(RESOURCE_TYPES.THEME, "themeEditor.createPage.open");

	resourceSvc.registerResourceView(RESOURCE_TYPES.THEME, "themeEditor.edit");

	registerCommands(dc);
	registerMenus(dc);
}
